import React from "react";
import { useWindowManager } from "../components/WindowManager";

const AccessDenied = () => {
  const { close } = useWindowManager();

  return (
    <div className="flex flex-col h-full px-4 pt-3 pb-3 desktop-font text-xl select-none">
      <div className="flex flex-1 items-start gap-4">
        <img
          src="/desktop-icons/error-icon.png"
          alt=""
          className="w-8 h-8 shrink-0 [image-rendering:pixelated]"
          draggable={false}
        />
        <p className="mt-1 leading-[1.1]">
          C:\ is not accessible.
          <br />
          <br />
          Access is denied.
        </p>
      </div>
      <div className="flex justify-center">
        <button
          className="w-[5.5rem] h-7 bg-[#c0c0c0] border-[0.13rem] border-t-white border-l-white border-b-black border-r-black outline-dotted outline-1 outline-offset-[-5px] active:border-t-black active:border-l-black active:border-b-white active:border-r-white"
          onClick={() => close("myComputer")}
        >
          <span className="mt-[0.2rem] inline-block">OK</span>
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
